import { Box, Grid } from '@mui/material';
import { useState, useEffect } from 'react';
import SlickSliderModule from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getImages } from '../services/ConfigurationDataHelperFunctions';
import { AppStore } from '../store';
import type { IMaterialImages } from '../../types';
import productImageNotFound from '../assets/png/ProductImageNotFound.png';
const Slider = (SlickSliderModule as any).default ?? SlickSliderModule;

export const ImageGallery = ({ variable }: any) => {
  const configuration = AppStore.getState().configuration;

  const images = getImages(variable, configuration);

  const [slideNumber, setSlideNumber] = useState(0);

  const handleOpenImage = (index: number) => {
    setSlideNumber(index);
  };

  useEffect(() => {
    const defaultImageIndex = images ? images.findIndex((i: IMaterialImages) => i.isDefault) : 0;
    setSlideNumber(defaultImageIndex && defaultImageIndex > -1 ? defaultImageIndex : 0);
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
  };

  return (
    <>
      {images && images.length > 0 ? (
        <Grid container sx={{ flexDirection: 'column' }} className="imageGrid">
          <Box className="fullScreenImage">
            <img src={images[slideNumber].url} alt="main-url" />
          </Box>
          {images.length > 1 && (
            <Box className="slider-wrapper">
              <Slider {...sliderSettings}>
                {images.map((slide: IMaterialImages, index: number) => (
                  <button
                    key={index + (slide?.description ?? '')}
                    className="slick-slide"
                    onClick={() => handleOpenImage(index)}
                  >
                    <img src={slide.url} alt="slide-url" />
                  </button>
                ))}
              </Slider>
            </Box>
          )}
        </Grid>
      ) : (
        <Grid container sx={{ flexDirection: 'column' }} className="noImageGrid">
          <Box className="text-center h-100 ">
            <img src={productImageNotFound} style={{ height: 'inherit' }} alt="image-not-found" />
          </Box>
        </Grid>
      )}
    </>
  );
};
